export default "__VITE_ASSET__BwKQqRpK__"